import React, { useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { F5 } from "@graylog/enterprise-api";
import formValidation from "./utils/formValidation";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { connectionString } = formData;
  const [loading, setLoading] = useState(false);
  const handleSubmit = () => {
    var _a, _b, _c;
    setLoading(true);
    F5.checkCredentials({
      management_ip: ((_a = formData == null ? void 0 : formData.managementIP) == null ? void 0 : _a.value) || "",
      username: ((_b = formData == null ? void 0 : formData.username) == null ? void 0 : _b.value) || "",
      password: ((_c = formData == null ? void 0 : formData.password) == null ? void 0 : _c.value) || ""
    }).then((result) => {
      if (result.result === "valid") {
        setFormError(null);
        onSubmit();
      } else {
        setFormError({
          full_message: result.result,
          nice_message: "Unable to connect to F5 BIG-IP using provided configuration."
        });
      }
      setLoading(false);
    }).catch((err) => {
      setLoading(false);
      setFormError({
        full_message: err.message,
        nice_message: "Unable to connect to F5 BIG-IP using provided configuration."
      });
    });
  };
  const isFormValid = formValidation.isFormValid(["f5Name", "managementIP", "username", "password"], formData);
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Verify Connection & Proceed",
      disabled: isFormValid,
      loading,
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "f5Name",
        type: "text",
        fieldData: formData.f5Name,
        onChange,
        placeholder: "Input Name",
        label: "Input Name",
        autoComplete: "off",
        help: "Select a name of your new input that describes it.",
        defaultValue: connectionString == null ? void 0 : connectionString.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "managementIP",
        type: "text",
        fieldData: formData.managementIP,
        onChange,
        label: "Management Server Host",
        help: "The IP address or host name of your F5 management server",
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "username",
        type: "text",
        onChange,
        fieldData: formData.username,
        label: "User Name",
        help: "User account with read access to logs.",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "password",
        type: "password",
        onChange,
        fieldData: formData.password,
        label: "Password",
        help: "A secret string of the user to prove its identity when requesting a token.",
        required: true
      }
    )
  );
};
export default StepAuthorize;
